import { render, staticRenderFns } from "./StarboxxTipComponent.vue?vue&type=template&id=75c5aa87&scoped=true&"
import script from "./StarboxxTipComponent.vue?vue&type=script&lang=js&"
export * from "./StarboxxTipComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c5aa87",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
